// @flow

import { rest } from 'msw'

export const postSentryApiMswHandler = rest.post('https://*.ingest.sentry.io/api/*', (req, res, ctx) => {
  return res(ctx.status(200))
})
